import React, { useContext, useState } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { OnboardingChecklistName } from '../../models/onboarding'

interface OnboardingProgressContextType {
  isVisible: boolean
  setIsVisible: HandlerOf<boolean>
  task: OnboardingChecklistName | null
  setTask: HandlerOf<OnboardingChecklistName | null>
  step: number | null
  setStep: HandlerOf<number | null>
}

const defaultValue = {
  isVisible: false,
  setIsVisible: () => null,
  task: null,
  setTask: () => null,
  step: 0,
  setStep: () => null,
}

const OnboardingProgressContext = React.createContext<OnboardingProgressContextType>(defaultValue)

interface OnboardingProgressProviderProps {
  children: React.ReactNode
}

export function OnboardingProgressProvider(props: OnboardingProgressProviderProps) {
  const [isVisible, setIsVisible] = useState(false)
  const [task, setTask] = useState<OnboardingChecklistName | null>(null)
  const [step, setStep] = useState<number | null>(null)

  function handleSetStep(newStep: number | null) {
    if (newStep && step && newStep < step) return
    setStep(newStep)
  }

  function handleSetTask(task: OnboardingChecklistName | null) {
    setTask(task)
  }

  return (
    <OnboardingProgressContext.Provider
      value={{
        isVisible,
        setIsVisible,
        task,
        setTask: handleSetTask,
        step,
        setStep: handleSetStep,
      }}
    >
      {props.children}
    </OnboardingProgressContext.Provider>
  )
}

export const useOnboardingProgressContext = () => {
  return useContext(OnboardingProgressContext)
}
